"use client"

import { useEffect, useState } from "react"
import { VercelToolbar } from "@vercel/toolbar/next"
import { isTestMode } from "@ahead-health/core/system-checks/testMode"

type State = "loading" | "show" | "suppress"

export function VercelToolbarWrapper() {
  const [state, setState] = useState<State>("loading")

  useEffect(() => {
    setState(isTestMode() ? "suppress" : "show")
  }, [])

  if (state === "loading") return null
  if (state === "suppress") {
    // Vercel auto-injects the toolbar's `<vercel-live-feedback>` custom
    // element on preview deployments at the edge, independent of the React
    // `<VercelToolbar />` component below. During browser tests the
    // unauthenticated "Continue with Vercel" prompt obscures page content
    // and confuses the agent's screenshot reasoning, so hide it whenever
    // the session is driven by the system test runner.
    return (
      <style
        dangerouslySetInnerHTML={{
          __html: `vercel-live-feedback { display: none !important; }`,
        }}
      />
    )
  }
  return <VercelToolbar />
}
